module.exports = __webpack_public_path__ + "static/media/twitter2.d319670b.gif";